import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';
import StudentRegistrationsHeaderButtons from './pages/registration-responses/components/header-buttons.vue';

const hdtcAgentRoutes = {
	path: 'hdtc',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.HDTC,
	},
	children: [
		{
			path: 'registration-responses',
			component: () => import('./pages/registration-responses/index.vue'),
			meta: {
				title: t('hdtc.students-registrations'),
				headerExtraComponent: StudentRegistrationsHeaderButtons,
			},
		},
		{
			path: 'academy-data',
			component: () => import('./pages/academy-data/index.vue'),
			meta: {
				title: t('hdtc.academy-data'),
			},
		},
		{
			path: 'learning-path/create',
			component: () => import('./pages/learning-path-editor/index.vue'),
			meta: {
				title: t('hdtc.create-learning-path'),
			},
		},
		{
			path: 'learning-path/update/:id',
			component: () => import('./pages/learning-path-editor/index.vue'),
			props: true,
			meta: {
				title: t('hdtc.update-learning-path'),
			},
		},
		{
			path: 'workshop/create',
			name: 'hdtc-workshop-editor',
			component: () => import('./pages/workshop-editor/index.vue'),
			meta: {
				title: t('hdtc.create-workshop'),
			},
		},
		{
			path: 'workshop/update/:id',
			name: 'hdtc-workshop-editor-edit',
			component: () => import('./pages/workshop-editor/index.vue'),
			props: true,
			meta: {
				title: t('hdtc.update-workshop'),
			},
		},
	],
};

export { hdtcAgentRoutes };
